<template>
  <el-card :body-style="{ padding: '30px 0 40px 0',width: '100%' }" class="card">
    <div slot="header">
      <el-image :src="pic" style="width: 100%; height: 100%"></el-image>
    </div>
    <div class="card-info">
      <div class="info-line">
        <span>总词汇量:</span>
        <span>{{bookWordCount}}</span>
      </div>
      <div class="info-line">
        <span>已学词量:</span>
        <span>{{record!=null?record.knowWord.length+record.unsureWord.length+record.missWord.length:0}}</span>
      </div>
      <div class="info-line">
        <span>生词数量:</span>
        <span>{{record!=null?record.unsureWord.length+record.missWord.length:0}}</span>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  props: ['pic','bookWordCount','record']
}
</script>

<style scoped>
.card{
  width: 80%;
  border-radius: 50px;
}
.card-info{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.info-line{
  width: 70%;
  margin-top: 10px;
  color: #000;
  font-size: 26px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
@media screen and (max-width: 1400px) {
  .card{
    border-radius: 30px;
  }
  .info-line{
    width: 80%;
    margin-top: 10px;
    color: #000;
    font-size: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
